import { Component, OnInit } from '@angular/core';
import { Order, OrderLine } from 'app/core/model/entity-model';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { AppInformationService, GenesisUnitOfWork } from '../../core/core.module';
import { default as validationEngine } from 'devextreme/ui/validation_engine';

@Component({
    selector: 'app-misc-line-dialog',
    templateUrl: './misc-line-dialog.component.html',
    styleUrls: ['./misc-line-dialog.component.scss'],
    standalone: false
})
export class MiscLineDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    orderId: number;
    orderLine: OrderLine;
    order: Order;
    priceValidationMessage = '';
    isWarranty = false;
    validationGroup = 'miscValidationGroup';
    errorAction = 'saving';
    mode: string;

    constructor(public modalRef: BsModalRef, private uow: GenesisUnitOfWork, private appInfo: AppInformationService) {}

    async ngOnInit() {
    }

    async save() {
        const result = this.validate();
        if (!result) return;

        if (!this.order.id) return;
        this.orderLine.orderId = this.order.id;
        this.result.next({ success: true, orderLine: this.orderLine });
    }

    close() {
        if (!this.order.id || this.mode === 'add') this.orderLine.entityAspect.setDeleted();
        else this.orderLine.entityAspect.rejectChanges();

        this.result.next(false);
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig(this.validationGroup);
        if (groupConfig) {
            const result = validationEngine.validateGroup(this.validationGroup);
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before ${this.errorAction}.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }
}
